import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { useReportIssueBaseStyles } from './styles';
import { schema } from './validation/schema';
import { useSelector, useDispatch } from 'react-redux';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';

const ReportIssueBase = ({ ...props }) => {
  const {
    mobile,
    motiveId,
    product,
    type,
    profile,
    name,
    label,
    buttonText,
  } = props;
  const classes = useReportIssueBaseStyles({ mobile });
  const [description, setDescription] = useState('');
  const [descriptionValidation, setDescriptionValidation] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [helper, setHelper] = useState('0/250');
  const [checked, setChecked] = useState(false);
  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { value } = event.target;
    setDescription(value);
    setHelper(`${value.length}/250`);
    if (value.length > 250) {
      setDescriptionValidation('error');
      setErrorMessage(`${value.length}/250`);
    } else {
      setDescriptionValidation('valid');
      setErrorMessage('');
    }
  };

  const handleValidation = () => {
    if (
      'error' in schema.validate({ description }) ||
      description.length > 250
    ) {
      setDescriptionValidation('error');
      setErrorMessage('Descripción es requerida');
    } else {
      setDescriptionValidation('valid');
      setErrorMessage('');
    }
  };

  const handleClick = () => {
    const body = bodyTicketProductGenerator({
      profile,
      type,
      motiveId,
      product,
      comment: description,
    });
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <AppInput
        name={`${name}Input`}
        multiline
        label={label}
        value={description}
        helperText={helper}
        onChange={handleChange}
        onBlur={handleValidation}
        success={descriptionValidation === 'valid'}
        error={descriptionValidation === 'error'}
        errorMessage={errorMessage}
        required
        onClick={() => {}}
      />
      <AuthorizeCheckbox
        onCheck={() => setChecked(!checked)}
        disabled={descriptionValidation !== 'valid'}
        idComplement={name}
      />
      <LoadingButton
        name={name}
        variant="contained"
        color="primary"
        text={buttonText}
        disabled={!checked || descriptionValidation !== 'valid'}
        className={classes.button}
        loading={ticketNoProductStatus === 'loading'}
        onClick={handleClick}
      />
    </Box>
  );
};

ReportIssueBase.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  buttonText: PropTypes.string,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default ReportIssueBase;
